// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"f7e40e56","511":"f5f44c75"}[chunkId] + ".chunk.css";
};